// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import App from './App'
import router from './router'
import './common/css/reset.css'
import './common/css/style.css'
import './common/font/iconfont.css'
import { getCookie } from './common/js/cookie'

import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import store from './store/store.js';
import i18n from './common/lang/i18n';

Vue.use(ElementUI, {
    size: 'small'
});



router.beforeEach((to, from, next) => {
  if(to.name === 'login' || to.name === 'registered') {  //如果是登录或註冊页，则跳过验证
    next();
    return;
  }
  if (!getCookie('merchant_token')) { // 判断当前的token是否存在
    next({
        path: '/login',
        query: { redirect: to.fullPath }
    })
    return;
  } else {
		// const roleId = getCookie('roleId');
    next()

		}


})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js